export default {
    value: {
        default() {
            return {
                year: new Date().getFullYear(),
                month: new Date().getMonth(),
            }
        },
        validator(value) {
            if (value.year !== undefined && value.month !== undefined) {
                return true;
            }
            console.warn("vue-month-selector: invalid v-model value");
            return false;
        }
    },
    color:
    {
        type:String
    },
    months: {
        type: Array,
        default: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月']
    }
};